import { GEOSPATIAL_PAGE } from './geospatial.config';

export function GeospatialHeader() {
  return (
    <header className="geo-layout__header geospatial-page-header">
      <p className="text-body">{GEOSPATIAL_PAGE.description}</p>
    </header>
  );
}
